<template>
  <div data-testid="outreach-contact-stat-label">
    <BaseLineClamp :lines="1"> {{ stat.text }}{{ suffix }} </BaseLineClamp>

    <BaseStreemTooltip>
      {{ stat.tooltip }}
    </BaseStreemTooltip>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { BaseLineClamp, BaseStreemTooltip } from "shared/components/base";
import {
  type OutreachContactStat,
  type OutreachContactStatProps,
  useOutreachContactSocialStats,
} from "shared/composables/useOutreachContactSocialStats";

const props = withDefaults(defineProps<OutreachContactStatProps>(), {
  suffix: "",
});

const { stats } = useOutreachContactSocialStats(props);

const stat = computed<OutreachContactStat>(() => stats.value[props.type]);
</script>
